import PaymentCollection from './finance/PaymentCollection';

/**
 * Legacy `/dashboard/finance/cloudgm/merchants/payments` route.
 * Redirects to the new Payment Collection UI scoped to `cloudgm_merchants`.
 */
export default function MerchantPayments() {
  return <PaymentCollection platformOverride="cloudgm_merchants" />;
}
